module.exports = __webpack_public_path__ + "img/data_exploration.b8565efd.svg";